'use client';
import { jsx } from 'react/jsx-runtime';
import { FloatingLabelContextProvider } from '../../contexts/internal/floating-label/index.js';
import { Combobox, comboboxPropTypes } from './combobox.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const ComboboxWithFloatingLabel = renderWithRef('Combobox', comboboxPropTypes, (e, a)=>{
    let { className: i, children: l } = e, m = new Set([
        'swan-combobox-with-floating-label',
        'swan-input-with-floating-label'
    ]);
    return i && m.add(i), jsx(FloatingLabelContextProvider, {
        children: jsx(RenderComp, {
            root: Combobox,
            forwardedRef: a,
            props: e,
            classNames: m,
            children: l
        })
    });
});

export { ComboboxWithFloatingLabel };
